import {
  TicketStatus,
  TicketPriority,
  AssignmentStatus,
  UserRole,
} from '@packages/database/types';

export interface QuickFilter {
  id: string;
  label: string;
  params: Record<string, string>;
  countKey?: keyof any;
}

export const QUICK_FILTERS: Record<string, QuickFilter[]> = {
  [UserRole.ADMIN]: [
    { id: 'all', label: 'All', params: {}, countKey: 'all' },
    {
      id: 'pendingClaim',
      label: 'Pending Claim',
      params: { assignmentStatus: 'PENDING_CLAIM' },
      countKey: 'pendingClaim',
    },
    {
      id: 'assigned',
      label: 'Assigned',
      params: { assignmentStatus: 'ASSIGNED' },
      countKey: 'assigned',
    },
    {
      id: 'unassigned',
      label: 'Unassigned',
      params: { assignmentStatus: 'UNASSIGNED' },
      countKey: 'unassigned',
    },
  ],
  [UserRole.CREW]: [
    { id: 'all', label: 'All', params: {}, countKey: 'all' },
    {
      id: 'mine',
      label: 'Mine',
      params: { assignedTo: 'me' },
      countKey: 'mine',
    },
    // {
    //   id: 'crew',
    //   label: 'Crew Tickets',
    //   params: { scope: 'crew' },
    //   countKey: 'crew',
    // },
  ],
};
